import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=18f0e6d8&scoped=true&"
import script from "./layout.vue?vue&type=script&lang=js&"
export * from "./layout.vue?vue&type=script&lang=js&"
import style0 from "./layout.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./layout.vue?vue&type=style&index=1&id=18f0e6d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f0e6d8",
  null
  
)

export default component.exports